import type { InteractiveContent } from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/legacy-series-types/question';
import { CORRECT_ANSWER_MODE_ENABLED } from '../../../constants';

export const correctAnswerModeToQuestionShowCorrect = (
  correctAnswerMode: InteractiveContent['correctAnswerMode'],
): Question['show_correct'] => {
  return correctAnswerMode === CORRECT_ANSWER_MODE_ENABLED;
};
